import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useNavigationType, useParams } from 'react-router-dom';
import { Card, CardContent, Grid, Typography, Link, Checkbox, Tooltip, Button, CircularProgress } from '@mui/material';
import { createJiraIcon, deleteIcon, digital, greenCheckIcon, hasJiraIcon, redCrossIcon } from '../assets';
import { DataGrid, Modal, TestResultStatusGrid, TestResultGrid } from '../ui';
import { useSelector } from 'react-redux';
import { getCurrentProject, getCurrentTestCase, getCurrentTestResult, getCurrentTestResultDetails } from '../store/selectors/project.selector';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { useAppDispatch } from '../store/hooks';
import { deleteTestCases, deleteTestResults, downloadFile } from "../services/testcase.service";
import { setCurrentProjectId, setCurrentTestCase, setCurrentTestResult, setCurrentTestResultDetails, setCurrentProject } from '../store/resuders/project.reducer';
import { getAllProjects } from '../store/selectors/project.selector';
import { SearchInput } from '../ui';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { getTestResultList, getTestResultlistDetails, getTestResultDetails, testRunStop, getexportlogFile, getLensLogFile } from '../services/testresults.service';
import { useNavigate } from "react-router-dom";
import { TestResultDetails } from './testResultsDetails';
import { getProjectById } from '../services/project.service';
import { formatTimestamp } from '../helpers/date.helper';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import PauseCircleFilledOutlinedIcon from '@mui/icons-material/PauseCircleFilledOutlined';
import { useTranslation } from 'react-i18next';
import { showHelpDetails, toggleAlert } from '../store/resuders/app.reducer';
import dayjs from 'dayjs';
import { appConfigSelector, getHelpCenter } from "../store/selectors/app.selector";
import InfoIcon from '@mui/icons-material/Info';
import { CHANNELS, CONFIGNAME } from '../types/global.enum';
import apiService from '../services/api.service';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import { baseLensApi, getVoiceApi } from '../services/config.service';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { JiraTicket } from './jira/jira.component';
import { uniqueId } from '../helpers/form.helper';
import { exportToFile } from '../helpers/exportToFile.helper';
import AudioPlayer from './AudioPlayer';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import IconButton from '@mui/material/IconButton'; // Import IconButton from Material-UI
import { set } from 'lodash';
export const TestResults = () => {
    // const projects = useSelector(getAllProjects);  // Contains all projects
    const { projectId, testCaseId, testResultId } = useParams();  // ProjectID and TestCaseID from URL
    console.log('[TestResults.tsx] Mounted. useParams:', { projectId, testCaseId, testResultId });
    const { t } = useTranslation();
    const navigationType = useNavigationType();

    const appConfig = useSelector(appConfigSelector);
    const project = useSelector(getCurrentProject);  // Store Project
    const testResult = useSelector(getCurrentTestResult)  // Store Test Case
    const testResultStatus = useSelector(getCurrentTestCase)
    const testResultDetails = useSelector(getCurrentTestResultDetails)  // Store Test Result Details

    const helpCenter = useSelector(getHelpCenter);

    const dispatch = useAppDispatch();
    const history = useNavigate();

    const currentDate: any = dayjs();
    const epochStartDate = new Date(0); // Represents the Unix epoch start

    const [data, setData] = useState<any>([]);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [remove, setRemove] = useState<any>([]);
    const [isOpen, setIsOpen] = useState<string>('');
    const [openJiraModal, setOpenJiraModal] = useState<string>('');
    const [startDateFilter, setStartDateFilter] = useState<any>(() => {
        const savedStartDate = localStorage.getItem("startDateFilter");
        return savedStartDate ? dayjs(parseInt(savedStartDate, 10)) : dayjs().subtract(1, 'year');
    });
    
    const [stopDateFilter, setStopDateFilter] = useState<any>(() => {
        const savedStopDate = localStorage.getItem("stopDateFilter");
        return savedStopDate ? dayjs(parseInt(savedStopDate, 10)) : dayjs(currentDate); // Use saved value or default current date
    });
    const [criteria, setCriteria] = useState<any>(() => {
        const initialPid = projectId;
        return {
            sort: '-recentStart',
            pageNo: 0,
            pageSize: 10,
            filter: localStorage.getItem("filter") || '', // Retrieve filter from localStorage or default to an empty string
            startDate: localStorage.getItem("startDateFilter") || new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getTime(),
            stopDate: localStorage.getItem("stopDateFilter") || currentDate.$d.getTime(), // Current date
            projectId: initialPid,
        };
    });
    console.log("testResultStatus", testResultStatus);
    // Effect to sync criteria.projectId if the projectId from URL changes
    // or if the Redux project changes and it's different from criteria's projectId
    useEffect(() => {
        const currentCriteriaPid = criteria.projectId;
        const pidFromUrl = projectId; // from useParams()
        const pidFromReduxProject = project?.data?.testProjectID;
     
        let newPidToUse = currentCriteriaPid;

        if (pidFromUrl && pidFromUrl !== currentCriteriaPid) {
            newPidToUse = pidFromUrl;
        } else if (pidFromReduxProject && pidFromReduxProject !== currentCriteriaPid && !pidFromUrl) {
            // This case might be less common if URL always dictates the project
            newPidToUse = pidFromReduxProject;
        }

        if (newPidToUse !== currentCriteriaPid) {
            console.log(`[TestResults.tsx] Syncing criteria.projectId from ${currentCriteriaPid} to ${newPidToUse}. Calling setCriteria.`);
            setCriteria((prevCriteria: any) => ({
                ...prevCriteria,
                projectId: newPidToUse,
                pageNo: 0, // Reset page number when project ID changes
            }));
        }
    }, [projectId, project, criteria.projectId]); // Watch URL projectId and Redux project

    const hasJiraEnabled = useMemo(()=>appConfig?.some(c=>c.configName === CONFIGNAME.JIRA && c.configValue) ,[appConfig])
    const [audioPosition, setAudioPosition] = useState<number[]>([]); // State to track audio playback position for each segment
    const [playingAudioIndex, setPlayingAudioIndex] = useState<number | null>(
        null
    ); // Index of the segment with playing audio
    const audioElementsRef = useRef<(HTMLAudioElement | null)[]>([]); // Ref to hold an array of <audio> elements
    
    // Track if we've already initiated loading for PUSH navigation to prevent infinite loops
    const pushLoadInitiated = useRef(false);

    // Holds the full-call recording retrieved for a specific test run (L3 view)
    const [testResultFullAudio, setTestResultFullAudio] = useState<any>(null);

    const isDigital = useMemo(()=> project?.data?.channelType === CHANNELS.DIGITAL ,[project]);

    const formatData = () => {
            if (data && Array.isArray(data)) {
            const aggregatedData = data.reduce((acc: any, result: any) => {
                if (!acc[result.testCaseId]) {
                    acc[result.testCaseId] = {
                        passed: result.status === 'PASS' ? 1 : 0,
                        failed: result.status === 'FAILED' ? 1 : 0,
                        totalCount: 1, // Initialize the total count
                        testCaseName: result.testCaseName,
                        passPercentage: result.passPercentage,
                        recentStart: result.recentStart,
                        projectId: result.projectId,
                        startTime: result.startTime, // Store the timestamp for comparison
                        // endTime: new Date(result.endTime).getTime(), // Store the timestamp for comparison
                        results: [result], // Initialize the results array with the current result
                        data: data,
                    };
                } else {
                    if (result.status === 'PASS') {
                        acc[result.testCaseId].passed++;
                    } else if (result.status === 'FAILED') {
                        acc[result.testCaseId].failed++;
                    }
                    acc[result.testCaseId].totalCount++; // Increment the total count
    
                    // Update startTime if the current startTime is earlier
                    const startTime = new Date(result.startTime).getTime();
                    if (startTime > acc[result.testCaseId].startTime) {
                        acc[result.testCaseId].startTime = startTime;
                    }
                    acc[result.testCaseId].results.push(result);
                }
    
                // Calculate the 'score' field
                acc[result.testCaseId].score = ((acc[result.testCaseId].passed / acc[result.testCaseId].totalCount) * 100).toFixed(1);
                return acc;
            }, {});
    
            const formattedData = {
                content: Object.keys(aggregatedData).map((testCaseId) => ({
                    ...aggregatedData[testCaseId],
                    testCaseId: parseInt(testCaseId, 10),
                    startTime: aggregatedData[testCaseId].startTime, // Use earliest startTime for each test case
                })),
            };
    
            return formattedData;
        } else {
            return null;
        }
    };
    

    // Function to find the earliest startTime
    function getEarliestStartTime(data: any) {
        if (data.length === 0) {
            return null; // Return null if the array is empty
        }

        let earliestStartTime = data[0].startTime;

        for (let i = 1; i < data.length; i++) {
            if (data[i].startTime < earliestStartTime) {
                earliestStartTime = data[i].startTime;
            }
        }
        return earliestStartTime;
    }


    // Function to find the latest endTime
    function getLatestEndTime(data: any) {
        if (data.length === 0) {
            return null; // Return null if the array is empty
        }

        let latestEndTime = data[0].endTime;

        for (let i = 1; i < data.length; i++) {
            if (data[i].endTime > latestEndTime) {
                latestEndTime = data[i].endTime;
            }
        }
        if (latestEndTime){
        return latestEndTime;
        } else{
             return new Date()
            }
    }
            const exportlogFile = (id: any) => async () => {
               try {
                    const { data } = await getexportlogFile(id); // Fetch the log data
                    exportToFile(data, `log_${id}.txt`, 'text/plain'); // Use the helper function
                } catch (error) {
                    console.error('Error exporting log file:', error);
                }
            };

            const exportLensLogFile = (id: any) => async () => {
                try {
                    const { data } = await getLensLogFile(id, project?.data?.channelType); // Fetch the Lens log data
                    exportToFile(data, `lens_log_${id}.txt`, 'text/plain');
                } catch (error) {
                    console.error('Error exporting Lens log file:', error);
                }
            };

    const loadJiraTicket = (params:any)=> async ()=> {
        const { data } = await getTestResultDetails(params?.id, +(project?.testProjectID || projectId || 1), project.data.channelType);
        dispatch(setCurrentTestResultDetails(data));

        if(!params.ignore) {
            createJiraTicket();
        }
    }



    // Columns for Test Results Status Page
    const testResultsColumns: any[] = [
        {
            caption: t('Sts'), width: '5%', fieldName: 'status',
            redner: (params: any) => (
                <div className="flex-center">
                    {params.lastRunStatus === 'RUNNING' ? <PendingOutlinedIcon style={{fill:'blue'}} />:<img src={params.lastRunStatus === 'PASS' ? greenCheckIcon : redCrossIcon} alt="" />}
                </div>
            ),
        },
        {
            fieldName: 'testCaseId', caption: t('ID'), sortable:true, width: '5%'
        },
        {
            fieldName: 'comment', caption: t(''), width: '3%',
            redner: (params: any) => 
                <div className="flex-center">
                {params.comment && (
                    <Tooltip
                        title={<span style={{ fontSize: '1rem', padding: '8px' }}>{params.comment}</span>}
                        arrow
                        PopperProps={{
                        modifiers: [
                            {
                            name: 'offset',
                            options: {
                                offset: [0, 10], // slight vertical offset
                            },
                            },
                        ],
                        }}
                        componentsProps={{
                        tooltip: {
                            sx: {
                            fontSize: '1rem',
                            padding: '12px 16px',
                            maxWidth: '300px',
                            color: 'white',
                            border: '1px solid #ccc',
                            boxShadow: 3,
                            },
                        },
                        }}
                    >
                        <InsertCommentIcon
                        style={{
                            fontSize: '20px', // make icon a bit larger
                            color: '#006a68',
                            margin: 'auto',
                            cursor: 'pointer',
                        }}
                        />
                    </Tooltip>
                    )}
                </div>
        },
        {
            fieldName: 'testCaseName', caption: t('Test Case Name'), sortable: true, width: '62%',
            redner: (params: any) => (
                <div className="flex-center">
                    <Link onClick={gotoTestCaseStatusPage(params)} className="a-link-black">
                        {params.testCaseName}
                    </Link>
                </div>
            )
        },
        {
            fieldName: 'passPercentage', caption: t('Passed'), sortable:true, width: '10%',
            redner: (params: any) => {
                return <span>{`${params.numPassed}/${params.numRuns} (${params.passPercentage}%)`}</span>;
            }
        },
        {
            fieldName: 'recentStart', caption: t('Date/Time'), sortable: true, width: '15%',
            redner: (params: any) => formatTimestamp(params.recentStart)
        },
    ];


    // Columns for Test Results Status Page
    const testStatusColumns: any[] = [
        { caption: 'ID', width: '7%', fieldName: 'id', sortable: false, key: true },
        hasJiraEnabled ? {
            caption: t('Jira'), width: '5%',
            redner: (params: any) => (
                <div className="flex-center">                    
                    {params.jiraTicket ? <div onClick={loadJiraTicket(params)} className='jira-ticket-link'><img src={hasJiraIcon} alt=""/></div> : <AddCircleOutlineIcon onClick={loadJiraTicket(params)}  className="blue-icon"/>}
                </div>
            ),
        }:{},
        {
            fieldName: 'testCaseName', caption: t('TEST CASE NAME'), width: '40%',
            redner: (params: any) => <div className="flex-center">
                <Link onClick={gotoTestCaseDetailsPage(params)} className="a-link-black">{params.testCaseName}</Link></div>
        },
        {
            fieldName: 'startTime', caption: t('DATE TIME'), width: '15%',
            redner: (params: any) => {
                const startTime = new Date(params.startTime);
                return (formatTimestamp(startTime))

            }
        },

        {
            fieldName: 'duration', caption: t('DURATION'), width: '10%',
            redner: (params: any) => {
                const startTime = new Date(params.startTime);
                const endTime = new Date(params.endTime);
                const durationMilliseconds = endTime.getTime() - startTime.getTime();
                const durationInSeconds = durationMilliseconds / 1000;
                if (durationInSeconds < 0) {
                    return `0 secs`;
                } else {
                    return `${durationInSeconds.toFixed(2)} secs`;
                }
            }
        },
        {
            fieldName: 'mosScore', caption: t('MOS'), width: '5%',
        },
        {
            fieldName: 'status', caption: t('STATUS'), width: '5%',
            redner: (params: any) => (
                <span style={{ color: params?.status === 'FAILED' || params?.status === 'FORCE_STOPPED' || params?.status === 'TIMEOUT' ? 'red' : params?.status === 'RUNNING' ? 'orange' : '#58A148' }}>
                    {params?.status}
                </span>
            )
        },
        {
            fieldName: 'action', width: '20%',
            caption: t('ACTION'),
            redner: (params: any) => {
                return <AudioPlayer recordingUrl={params?.recordingUrl} rowId={params?.id} />;
            },
            
            
        }
    ];

    // Columns for Test Results Status Page
    const testDetailsColumns: any[] = [
        { caption: t('Test Case ID'), width: '55px', fieldName: 'id' },
        { caption: t('Test Case Name'), width: '55px', fieldName: 'name' },
        {
            caption: t('MOS Score'), width: '55px', fieldName: 'mos',
            redner: (params: any) => {
                return `${params.data.testResult.voice.mos}`;
            }
        },
        {
            caption: t('Test Run ID'), width: '55px', fieldName: 'testRunId',
            redner: (params: any) => {
                return `${params.data.testResult.id}`;
            }
        },
        {
            caption: t('From'), width: '55px', fieldName: 'creationTime',
            redner: (params: any) => {
                // return `${formatDate(params.data.testResult?.startTime)} to ${formatDate(params.data.testResult?.endTime)}`;
                return `${formatTimestamp(params.data.testResult?.startTime)} to ${formatTimestamp(params.data.testResult?.endTime)}`;
            }
        },
        {
            caption: t('Duration'), width: '55px', fieldName: 'duration',
            redner: (params: any) => {
                const startTime = new Date(params.data.testResult.startTime);
                const endTime = new Date(params.data.testResult.endTime);
                const durationMilliseconds = endTime.getTime() - startTime.getTime();
                const durationInSeconds = durationMilliseconds / 1000;
                if (durationInSeconds < 0) {
                    return `0 secs`;
                } else {
                    return `${durationInSeconds.toFixed(2)} secs`;
                }
            }
        }
    ];


    // ---------------------------------------------------------------------------
    // View logic  ───────────────────────────────────────────────────────────────
    // Instead of tracking the visible panel with local state, derive it entirely
    // from the current URL params so that the URL is the single source-of-truth.
    //   L1  →  /project/:projectId/testresults                     (viewLevel 1)
    //   L2  →  /project/:projectId/testresults/:testCaseId         (viewLevel 2)
    //   L3  →  /project/:projectId/testresults/:testCaseId/:runId  (viewLevel 3)
    // ---------------------------------------------------------------------------
    const viewLevel = useMemo(() => {
        if (testResultId) return 3;        // Details
        if (testCaseId)   return 2;        // Status list for a testcase
        return 1;                          // Project-wide results list
    }, [testResultId, testCaseId]);

    // Derive booleans used throughout the old render logic to minimise changes
    const testResultsPage = viewLevel === 1;   // L1
    const testStatusPage  = viewLevel === 2;   // L2
    const testDetailsPage = viewLevel === 3;   // L3

    // Helper to navigate explicitly back to the top-level results list (L1).
    const openTestResultsView = () => {
        // Reset page number when returning to L1 view
        setCriteria((prevCriteria: any) => ({
            ...prevCriteria,
            pageNo: 0,
        }));
        history(`/folders/project/${project?.testProjectID || projectId}/testresults`);
    }

    // Loading indicator for L2 view
    const [loadingStatus, setLoadingStatus] = useState(false);
    // Preserve pagination totalPages during loading for L2
    const [l2TotalPages, setL2TotalPages] = useState(0);

    // Loading indicator for L1 results list
    const [loadingList, setLoadingList] = useState(false);
    const [isPaging, setIsPaging] = useState(false); // Flag for pagination fetches

    // Legacy helper kept as a no-op for backward compatibility (URL now drives view)
    const openTestResultsStatusView = () => {};

    const checkProjectData = async ()=> {
        let currentProject:any = {...project};

        if(!project?.data) {
            const  data  = await getProjectById(+(projectId || '0'));
            dispatch(setCurrentProject(data));
            currentProject = {...data};
        }

        return currentProject;
    }

    // Navigate to L2 (status) for a test case, showing a spinner immediately
    const gotoTestCaseStatusPage = (testCase: any, navigate = true) => () => {

        // Reset page number when entering L2 view
        // setCriteria((prevCriteria: any) => ({
        //     ...prevCriteria,
        //     pageNo: 0, 
        // }));
        // setL2TotalPages(0); // Reset preserved total pages too

        // Start loading indicator synchronously
        setLoadingStatus(true);
        // Navigate immediately so L2 view (and its spinner) renders before fetch completes
        if (navigate) {
            history(`/folders/project/${project?.data?.testProjectID || projectId}/testresults/${testCase?.testCaseId || testCaseId}`);
        }
        // Run the async fetch logic in an IIFE so the wrapper returns quickly and allows a repaint
        (async () => {
            try {

                const savedManualL1TestResultId = localStorage.getItem("ManualL1TestResultId");
                const testcasetId = testCase?.testCaseId || testCaseId;
                if (Number(savedManualL1TestResultId) !==  Number(testcasetId)) { // Ensure both are numbers
                    // If the testCaseId is different from the saved one, reset the page number
                    localStorage.setItem("ManualL2currentPage", '0'); // Reset to page 0
                    localStorage.setItem("ManualL2itemsPerPage", '10'); // Reset to default items per page
                    localStorage.setItem("ManualL1TestResultId", testcasetId); // Store the current test case ID
                }
         
                // Dispatch testCase summary for breadcrumb/header
                dispatch(setCurrentTestResult(testCase));
                const currentProject = await checkProjectData();

                const pageSize = localStorage.getItem("ManualL2itemsPerPage")
                    ? parseInt(localStorage.getItem("ManualL2itemsPerPage")!, 10)
                    : 10; // Fallback to default value of 10
                
                const pageNo = localStorage.getItem("ManualL2currentPage")
                    ? parseInt(localStorage.getItem("ManualL2currentPage")!, 10)
                    : 0; // Fallback to default value of 0
               
                // Fetch list pages (now using pageNo 0 from the reset criteria)
                const { data: tempData } = await getTestResultlistDetails(
                    testCase?.projectId || projectId,
                    testCase?.testCaseId || testCaseId,
                    pageSize, 
                    pageNo, // Explicitly use 0 here as criteria might not update immediately
                    criteria.startDate,
                    criteria.stopDate,
                    currentProject.data.channelType
                );
                const { data } = await getTestResultlistDetails(
                    testCase?.projectId || projectId,
                    testCase?.testCaseId || testCaseId,
                    pageSize,
                    pageNo, // Explicitly use 0 here as well
                    criteria.startDate,
                    criteria.stopDate,
                    currentProject.data.channelType
                );
                // Set runs list in Redux
                dispatch(setCurrentTestCase(data));
                // Store the total pages in our local state too
                setL2TotalPages(data?.totalPages || 0);
                // Ensure name propagation
                const fetchedName = data?.content?.[0]?.testCaseName;
                if (fetchedName) {
                    dispatch(setCurrentTestResult({
                        ...testCase,
                        testCaseName: fetchedName,
                    }));
                }
            } catch (error) {
                console.error('Error loading test case status list', error);
            } finally {
                setLoadingStatus(false);
            }
        })();
    }

    const gotoTestCaseDetailsPage = (testResult: any) => async () => {
        const downloadedTestResultFullAudio : Blob = await downloadFile(testResult?.id);
        setTestResultFullAudio(downloadedTestResultFullAudio);

        history(`/folders/project/${project?.testProjectID || projectId}/testresults/${testResult.testCaseId}/${testResult?.id}`);
    }


    const loadData = async () => {
        console.log('[TestResults.tsx] loadData called. Current criteria.projectId:', criteria.projectId, 'URL projectId:', projectId);
        const pidToLoad = criteria.projectId || projectId; // Prefer criteria.projectId if available
        if (!pidToLoad) {
            console.warn('[TestResults.tsx] loadData: No projectId available to load project details.');
            return;
        }
        console.log('[TestResults.tsx] loadData: Fetching project details for projectId:', pidToLoad);
        const projectData = await getProjectById(Number(pidToLoad));
        console.log('[TestResults.tsx] loadData: Fetched projectData:', projectData);
        dispatch(setCurrentProject(projectData));
        dispatch(setCurrentProjectId(String(pidToLoad))); // Ensure Redux currentProjectId is also set
    };
    const getData = async () => {
        console.log('[TestResults.tsx] getData called. Criteria:', JSON.stringify(criteria), 'Redux project channelType:', project?.data?.channelType);
        if (!criteria.projectId || !project?.data?.channelType) {
            console.warn('[TestResults.tsx] getData: Missing criteria.projectId or project.data.channelType. Aborting fetch.');
            return;
        }
        // Only show spinner if not just changing pages
        if (!isPaging) {
            setLoadingList(true);
        }

        try {
            const pageSize = localStorage.getItem("ManualL1itemsPerPage")
                    ? parseInt(localStorage.getItem("ManualL1itemsPerPage")!, 10)
                    : 10; // Fallback to default value of 10
                
                const pageNo = localStorage.getItem("ManualL1currentPage")
                    ? parseInt(localStorage.getItem("ManualL1currentPage")!, 10)
                    : 0; // Fallback to default value of 0
     

            const { data: fetchedData } = await getTestResultList(
                criteria.projectId,
                pageSize,
                pageNo,
                criteria.filter,
                criteria.startDate,
                criteria.stopDate,
                project.data.channelType,
                criteria.sort
            );
            console.log('[TestResults.tsx] getData: Fetched list data:', fetchedData);
            setData(fetchedData?.content);
            setTotalPages(fetchedData?.totalPages || 0);
        } catch (error) {
            console.error('[TestResults.tsx] Error fetching results list', error);
            setData([]);
            setTotalPages(0);
        } finally {
            setLoadingList(false);
            setIsPaging(false); // Reset paging flag after fetch completes
        }
    }
    useEffect(() => {
       
        console.log('[TestResults.tsx] useEffect[viewLevel, project, criteria.projectId, testCaseId, navigationType] running. viewLevel:', viewLevel, 'navType:', navigationType, 'projectId:', criteria.projectId, 'testCaseId:', testCaseId);
        if (viewLevel === 1 && project && project.data?.testProjectID == criteria.projectId) {
            getData();
        }
        // Only auto-fetch L2 on POP (direct/back/refresh) navigation
        // Don't handle L3 here - that's handled by the criteria useEffect
        if (viewLevel === 2 && navigationType === 'POP' && testCaseId && projectId) {
            // Use projectId from URL params for POP navigation, no need to wait for project data
            gotoTestCaseStatusPage({ testCaseId: Number(testCaseId), projectId: Number(projectId) }, false)();
        }
    }, [viewLevel, project, criteria.projectId, testCaseId, navigationType, projectId]);

    // Separate effect for PUSH navigation to L2 to avoid infinite loops
    useEffect(() => {
        // Reset flag when testCaseId changes to allow loading different test cases
        pushLoadInitiated.current = false;
        
        // Only fetch once per navigation to prevent infinite loop
        if (viewLevel === 2 && navigationType === 'PUSH' && testCaseId && project && project.data?.testProjectID === Number(projectId) && !pushLoadInitiated.current) {
            pushLoadInitiated.current = true;
            gotoTestCaseStatusPage({ testCaseId: Number(testCaseId), projectId: Number(projectId) }, false)();
        }
    }, [viewLevel, navigationType, testCaseId, projectId, project?.data?.testProjectID]);

    // Effect to handle pagination changes for L2 view
    useEffect(() => {
      
        // Only run for L2 view when we have the necessary data and are explicitly changing pages
        if (viewLevel === 2 && testCaseId && isPaging && project?.data?.channelType) {
            
            (async () => {
                try {
                    // Don't show loading spinner for pagination
                    const currentProject = await checkProjectData();

                    const pageSize = localStorage.getItem("ManualL2itemsPerPage")
                    ? parseInt(localStorage.getItem("ManualL2itemsPerPage")!, 10)
                    : 10; // Fallback to default value of 10
                
                    const pageNo = localStorage.getItem("ManualL2currentPage")
                    ? parseInt(localStorage.getItem("ManualL2currentPage")!, 10)
                    : 0; // Fallback to default value of 0

                    
                    // Fetch L2 results with the updated page number
                    const { data } = await getTestResultlistDetails(
                        Number(project?.data?.testProjectID || projectId),
                        Number(testCaseId),
                        pageSize,
                        pageNo,
                        criteria.startDate,
                        criteria.stopDate,
                        currentProject.data.channelType
                    );
                    
                    // Update Redux store with new paged data
                    dispatch(setCurrentTestCase(data));
                    // Also update our local storage of total pages
                    setL2TotalPages(data?.totalPages || 0);
                } catch (error) {
                    console.error('Error loading paginated test case status list', error);
                } finally {
                    setIsPaging(false);
                }
            })();
        }
    }, [criteria.pageNo, viewLevel, testCaseId, project?.data?.channelType, isPaging]);

    const playAudio = (attachmentUrl: string | undefined) => {
        if (attachmentUrl) {
            const desiredURL = attachmentUrl

            // Create an audio element if it doesn't exist
            if (!audioElementsRef.current[0]) {
                const audio = new Audio(desiredURL);

                audio.addEventListener("ended", () => {
                    setPlayingAudioIndex(null); // Reset the playing audio index
                });

                audioElementsRef.current[0] = audio;
            }

            const audioElement = audioElementsRef.current[0];

            if (audioElement.paused) {
                // If the audio is paused, play it
                audioElement.play();
                setPlayingAudioIndex(0);
            } else {
                // If the audio is playing, pause it
                audioElement.pause();
                setPlayingAudioIndex(null);
            }
        }
    };



    // const sortChanged = (column: string, direction: string) => {
    //     if (column === 'startTime') {
    //         setCriteria({
    //             ...criteria,
    //             pageNo: 0,
    //             sort: `${direction === 'ASC' ? '+' : '-'}startTime`,
    //         });
    //     } else {
    //         setCriteria({
    //             ...criteria,
    //             pageNo: 0,
    //             sort: `${direction === 'ASC' ? '+' : '-'}${column}`,
    //         });
    //     }
    // };
    const sortChanged = (column: string, direction: string) => {

        // if (column === 'startTime') {
        //     setCriteria({
        //         ...criteria,
        //         pageNo: 0,
        //         sort: `${direction === 'ASC' ? '+' : '-'}startTime`,
        //     });
        // } else if (column === 'status') {
        //     // Handle sorting by the 'status' field
        //     setCriteria({
        //         ...criteria,
        //         pageNo: 0,
        //         sort: `${direction === 'ASC' ? '+' : '-'}score`,
        //     });
        // } else {
            setCriteria({
                ...criteria,
                pageNo: 0,
                sort: `${direction === 'ASC' ? '+' : '-'}${column}`,
            });
        // }
    };
    

    const pageChanged = (page: number) => {
        setIsPaging(true); // Set flag before updating criteria
        setCriteria({
            ...criteria,
            pageNo: page - 1,
        })
    }

    const pageSizeChanged = (size: number) => {
        
        setIsPaging(true); // Set flag before updating criteria
        setCriteria({
            ...criteria,
            pageSize: size,
        })
    }

    

    const selectionChanged = (id: any) => {
        setRemove(id);
    }

    const deleteSelected = async () => {
        if (remove?.length) {
            setIsOpen(`${new Date().getTime()}`);
        }
    }

    const deleteTestResult = async () => {
        await deleteTestResults(project?.data?.testProjectID, remove);
        await gotoTestCaseStatusPage(testResultStatus, false)();
        setRemove([]);
    }

    const handleClearFilter = async () => {
            setStartDateFilter(null);
            setStopDateFilter(null);
            onFilterChanged(''); // Clear filter text
            setCriteria({
                ...criteria,
                filter: '',
                startDate: epochStartDate.getTime(), // Reset to epoch start
                stopDate: currentDate.$d.getTime() // Reset to current date
            });
        
    }



    const onFilterChanged = (filter: string) => {
        if(startDateFilter || stopDateFilter){
            if(startDateFilter && stopDateFilter){
                setCriteria({
                    ...criteria,
                    pageNo: 0,
                    pageSize: 10,
                    filter,
                    startDate: startDateFilter.$d.getTime(),
                    stopDate: stopDateFilter.$d.getTime()
                })
            } else{
                dispatch(toggleAlert('Please pick both start and stop date.'));
            }
        }else{
            setCriteria({
                ...criteria,
                pageNo: 0,
                filter
            })
        }
        localStorage.removeItem('ManualL1currentPage');
        localStorage.removeItem('ManualL2currentPage');
        localStorage.removeItem('ManualL1itemsPerPage');
        localStorage.removeItem('ManualL2itemsPerPage');
        localStorage.setItem("filter", filter); // Save filter in localStorage
    }

    const onStartDateChanged = (startDate: any) => {
        console.log(startDate);
        if (!startDate) {
            setStartDateFilter(null);
            localStorage.removeItem("startDateFilter"); // Remove from localStorage if no start date
            return;
        }
        if (typeof startDate === 'object') {
            setStartDateFilter(startDate);
            localStorage.setItem("startDateFilter", startDate.$d.getTime().toString()); // Save start date in localStorage
        }
        setCriteria({
            ...criteria,
            startDate: startDate.$d.getTime(),
        });
    };

    const onStopDateChanged = (stopDate: any) => {
        if(!stopDate){
            setStopDateFilter(null);
            localStorage.removeItem("stopDateFilter"); // Remove from localStorage if no start date
            return;
        }

        if (stopDate) {
            setStopDateFilter(stopDate);
            localStorage.setItem("stopDateFilter", stopDate.$d.getTime().toString()); // Save start date in localStorage
        }
         
        setCriteria({
            ...criteria,
            stopDate: stopDate.$d.getTime()
        })
    }

    const formatDate = (dateTimeString: any) => {
        if (!dateTimeString) return '';

        const date = new Date(dateTimeString);
        const formattedDate = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
        return formattedDate;
    };


    const createJiraTicket = ()=> {
        setOpenJiraModal(uniqueId());
    }

    useEffect(() => {
        console.log('[TestResults.tsx] useEffect[criteria] running. Criteria:', JSON.stringify(criteria), 'testResultId:', testResultId, 'testCaseId:', testCaseId, 'viewLevel:', viewLevel, 'navType:', navigationType);

        const fetchAndSetTestRunDetails = async () => {
            const projectIdToUse = criteria.projectId || projectId;
            if (testResultId && projectIdToUse && project?.data?.channelType) {
                console.log(`[TestResults.tsx] Fetching details for testResultId: ${testResultId}, projectId: ${projectIdToUse}`);
                try {
                    const numericTestResultId = Number(testResultId);
                    if (isNaN(numericTestResultId)) {
                        console.error('[TestResults.tsx] Invalid non-numeric testResultId:', testResultId);
                        dispatch(setCurrentTestResultDetails(null));
                        return;
                    }
                    const details = await getTestResultDetails(numericTestResultId, Number(projectIdToUse), project.data.channelType);
                    console.log('[TestResults.tsx] Fetched test run details:', details);
                    dispatch(setCurrentTestResultDetails(details.data)); // Assuming details service returns { data: ... }
                    // Also fetch full audio for the details view if needed here
                    const audioBlob : Blob = await downloadFile(numericTestResultId); // testResultId is the run ID
                    setTestResultFullAudio(audioBlob);

                } catch (error) {
                    console.error('[TestResults.tsx] Error fetching test run details:', error);
                    dispatch(setCurrentTestResultDetails(null)); // Clear on error
                }
            }
        };

        if (criteria.projectId || projectId) {
            if (testResultId) {
                // --- L3 View Logic ---
                console.log(`[TestResults.tsx] useEffect[criteria] - Targeting L3 (testResultId: ${testResultId}). Fetching details.`);
                loadData(); // Load project if needed
                fetchAndSetTestRunDetails();
                // Clear L2 list data when viewing L3 details
                dispatch(setCurrentTestCase(null));
            } else {
                // --- L1 or L2 View Logic ---
                console.log(`[TestResults.tsx] useEffect[criteria] - Targeting L1 or L2 (testResultId is null).`);

                // Load base project data if needed (but avoid double-loading on POP to L2)
                if (!(viewLevel === 2 && navigationType === 'POP')) {
                    console.log('[TestResults.tsx] useEffect[criteria] calling loadData() for L1/L2 (non-POP).');
                    loadData();
                }

                // Clear L2 list data *only* if we are certain we are on L1.
                // We DON'T clear if we are on L2, because Effect 1 handles loading for both POP and PUSH.
                if (viewLevel === 1) {
                     console.log(`[TestResults.tsx] useEffect[criteria] - Clearing L2 data (viewLevel: ${viewLevel}).`);
                     dispatch(setCurrentTestCase(null));
                } else {
                     console.log(`[TestResults.tsx] useEffect[criteria] - Skipping L2 data clear because viewLevel is ${viewLevel} and Effect 1 handles L2 loading.`);
                }

                // L3 details are definitely not relevant if testResultId is null
                dispatch(setCurrentTestResultDetails(null)); // Clear L3 details if not on L3
            }
        } else {
            console.log('[TestResults.tsx] useEffect[criteria] skipped due to no criteria.projectId');
        }
    // Ensure all dependencies that could trigger re-fetch or view change are included.
    // project?.data?.channelType is crucial for getTestResultDetails.
    // testResultId, testCaseId from useParams directly influence logic.
    // Added viewLevel and navigationType because the internal logic now depends on them.
    }, [criteria, testResultId, testCaseId, project?.data?.channelType, dispatch, viewLevel, navigationType, projectId]);


    const closeJiraModal = async (saved?:boolean)=> {
        setOpenJiraModal('');

        if(saved) {
            await loadJiraTicket({
                ignore:true,
                id:testResultDetails?.testResult?.id
            })()
        }
    }

    const handleStopTestRun = async ()=> {
        console.log('testResultId', testResultDetails?.testResult?.id);
        const { data } = await testRunStop(testResultDetails?.testResult?.id);
        if(data) {
            dispatch(toggleAlert('Test run stopped successfully.'));
        }
        window.location.reload();
    }


    const gridItemSize = 12


    return (
        <DndProvider backend={HTML5Backend}>
            <Grid container>
                {/* Header */}
                <Grid item xs={testResultsPage ? 6 : 12} paddingTop={'16px'} paddingBottom={'10px'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', height: '100%' }}>
                        <Typography variant="subtitle2">{t('Project')} :</Typography>
                        <Typography variant="subtitle2">{project ? project?.data?.testProjectID : projectId}</Typography>
                        {project?.data?.channelType === CHANNELS.VOICE ? (<PhoneEnabledOutlinedIcon style={{ fontSize: '17px' }} />) : (<img src={digital} alt="" width={17}/>)}
                        {project ?
                            <>
                                <Typography variant="subtitle2">
                                    <Link
                                        onClick={() => {
                                            // Navigate back to the main project view
                                            if (projectId) { // projectId from useParams()
                                                console.log(`[TestResults.tsx] Project breadcrumb clicked. Navigating to: /folders/project/${projectId}`);
                                                history(`/folders/project/${projectId}`);
                                            } else {
                                                console.error("[TestResults.tsx] Project breadcrumb clicked, but projectId is missing from URL params.");
                                                // Optional fallback, e.g., navigate to root folders view
                                                // history('/folders');
                                            }
                                        }}
                                        className="a-link-black"
                                    >
                                        {project?.data?.name}
                                    </Link>
                                </Typography>
                            </>
                            : null}
                            <Typography variant="subtitle2">{'>'}</Typography>
                            <Typography variant="subtitle2">
                                <Link
                                    onClick={() => {
                                        openTestResultsView();
                                    }}
                                    className="a-link-black"
                                >
                                    {t('Manual Test Results')}
                                </Link>
                            </Typography>
                        {(testStatusPage || testDetailsPage) &&
                            <>
                                <Typography variant="subtitle2">{'>'}</Typography>
                                <Link
                                    onClick={() => {
                                        // Reset page number when navigating to L2
                                        setCriteria((prevCriteria: any) => ({ ...prevCriteria, pageNo: 0 }));
                                        // Navigate to L2 using the correct function
                                        gotoTestCaseStatusPage({
                                            // Use testCaseId from L3 details if available, otherwise from L2 state/URL param
                                            testCaseId: testDetailsPage ? testResultDetails?.testCaseId : (testResult?.testCaseId || testCaseId),
                                            projectId: projectId // Use projectId from URL params
                                        }, true)(); // Invoke the returned function
                                    }}
                                    className="a-link-black"
                                >
                                    <Typography variant="subtitle2">
                                        {/* Always display the test case name in breadcrumb */}
                                        {testStatusPage // On L2, use name from testResult (populated by L2 fetch)
                                            ? testResult?.testCaseName
                                            : testResultDetails?.name} {/* On L3, use name from testResultDetails */}
                                    </Typography>
                                </Link>
                            </>
                        }
                        {testDetailsPage &&
                            <>
                                <Typography variant="subtitle2">{'>'}</Typography>
                                <Typography variant="subtitle2">{testResultDetails?.testResult?.id || testResultDetails?.testResult?.resultId}</Typography>
                                <Button  variant="outlined" color="info" onClick={exportlogFile(testResultDetails?.testResult?.id)} >NVP LOGS</Button>
                                <Button  variant="outlined" color="info" style={{ marginLeft: '8px' }} onClick={exportLensLogFile(testResultDetails?.testResult?.id)} >LENS LOGS</Button>
                                {hasJiraEnabled && 
                                    <>
                                        {testResultDetails?.testResult?.jiraTicket ? <div onClick={createJiraTicket} className='jira-ticket-link justify-end'><img src={hasJiraIcon} alt=""/> {t('Check Jira Status')}</div> : <div onClick={createJiraTicket} className='jira-ticket-link justify-end'><AddCircleOutlineIcon className="blue-icon"/> {t('Create a Jira Ticket')}</div>}
                                    </>
                                }
                                {testResultDetails?.testResult?.status === 'RUNNING' ? <Button variant="outlined" color="error" style={{ marginRight: "10px" }} onClick={handleStopTestRun}> STOP </Button> : "" }
                            </>
                        }
                        {helpCenter && <div onClick={()=>dispatch(showHelpDetails(''))} className="help-icon-float-right"><InfoIcon /></div>}
                    </div>
                </Grid>


                {/* Case Editor or DataGrid */}
                {testResultsPage && (
                    loadingList ? (
                        <Grid item xs={gridItemSize} paddingRight={'9px'}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '20px' }}>
                                <CircularProgress />
                            </div>
                        </Grid>
                    ) : (
                        <Grid item xs={gridItemSize} paddingRight={'9px'}>
                            <div>
                                {helpCenter && <div onClick={()=>dispatch(showHelpDetails('Test Results'))} className="help-icon-float"><InfoIcon /></div>}
                                <Card>
                                    <CardContent>
                                        <div className='test-result-header'>
                                            <div className="action-header">
                                                {/* <FileUploadOutlinedIcon style={{ fontSize: '30px' }} />
                                                <img src={deleteIcon} alt={t('Remove')}onClick={deleteSelected} /> */}
                                            </div>
                                            <div className="test-results-filters">
                                                <DatePicker
                                                    value={startDateFilter}
                                                    format='YYYY/MM/DD'
                                                    label={t("Start Date")}
                                                    className='start-date-field'
                                                    onChange={onStartDateChanged}
                                                    slotProps={{ textField: { size: 'medium' }}}
                                                />
                                                <DatePicker
                                                    value={stopDateFilter}
                                                    format='YYYY/MM/DD'
                                                    label={t("Stop Date")}
                                                    className='stop-date-field'
                                                    onChange={onStopDateChanged}
                                                    slotProps={{ textField: { size: 'medium' }}}
                                                />
                                                <SearchInput onFilter={onFilterChanged} defaultValue={criteria.filter}  />
                                                <Tooltip title={t("Clear Filters")} arrow>
                                                    <IconButton
                                                        className="clear-filter-button"
                                                        onClick={handleClearFilter}
                                                        aria-label={t("Clear Filters")}
                                                    >
                                                        <RefreshOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <TestResultGrid 
                                            pageChanged={pageChanged} 
                                            totalPages={totalPages}
                                            sortChanged={sortChanged}
                                            columns={testResultsColumns} 
                                            data={data} 
                                            selection={false} 
                                            sortBy={criteria.sort}
                                            selectionChanged={selectionChanged}
                                            pageSizeChanged={pageSizeChanged}
                                            currentPage={
                                                localStorage.getItem("ManualL1currentPage")
                                                    ? parseInt(localStorage.getItem("ManualL1currentPage")!, 10)
                                                    : criteria.pageNo + 1 // Fallback to criteria.pageNo + 1
                                            } />
                                    </CardContent>
                                </Card>
                            </div>
                            
                        </Grid>
                    )
                )}
                {testStatusPage && (
                    loadingStatus ? (
                        <Grid item xs={gridItemSize} paddingRight={'9px'}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', padding: '20px' }}>
                                <CircularProgress />
                            </div>
                        </Grid>
                    ) : (
                        <Grid item xs={gridItemSize} paddingRight={'9px'}>
                            <Card>
                                <CardContent>
                                    <div className='test-result-header'>
                                        <div className="action-header">
                                            <img src={deleteIcon} alt={t('Remove')}onClick={deleteSelected} />
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', height: '100%' }}>
                                                <Typography variant="subtitle2"><strong>{t('Test Case ID')}:</strong> #{testResult?.testCaseId}</Typography>
                                                <Typography variant="subtitle2"><strong>{t('Test Case Name')}:</strong> {testResult?.testCaseName}</Typography>
                                                <Typography variant="subtitle2">
                                                    {/* <strong>From:</strong> {formatDate(testResult?.startTime)} to {formatDate(testResult?.endTime)} */}
                                                    <strong>{t('From')}:</strong> {formatTimestamp(getEarliestStartTime(testResultStatus?.content || []))} to {formatTimestamp(getLatestEndTime(testResultStatus?.content || []))}
                                                </Typography>
                                            </div>
                                            {testResult?.comment && (
                                            <Tooltip title={testResult?.comment}  arrow>
                                                <InsertCommentIcon style={{ cursor: 'pointer' }} />
                                            </Tooltip>
                                            )}
                                        </div>
                                        {/* <div className="test-results-filters">
                                            <SearchInput onFilter={onFilterChanged} />
                                        </div> */}
                                    </div>
                                    <TestResultStatusGrid
                                        pageChanged={pageChanged}
                                        totalPages={testResultStatus?.totalPages || l2TotalPages}
                                        sortChanged={sortChanged}
                                        columns={testStatusColumns.filter(c=>!isDigital || (c.fieldName !== 'mosScore' && c.fieldName !== 'action'))}
                                        data={
                                            testResultStatus?.content || []
                                        }
                                        selection={true}
                                        sortBy={criteria.sort}
                                        selectionChanged={selectionChanged}
                                        currentPage={
                                            localStorage.getItem("ManualL2currentPage")
                                                ? (parseInt(localStorage.getItem("ManualL2currentPage")!, 10) === 0
                                                    ? 1 // Add 1 if ManualL2currentPage is 0
                                                    : parseInt(localStorage.getItem("ManualL2currentPage")!, 10)) // Use the value directly if not 0
                                                : criteria.pageNo + 1 // Fallback to criteria.pageNo + 1
                                        }
                                        pageSizeChanged={pageSizeChanged}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                    )
                )}

                {testDetailsPage && (
                    <TestResultDetails
                        pageChanged={pageChanged}
                        totalPages={data?.totalPages || 0}
                        sortChanged={sortChanged}
                        columns={testDetailsColumns}
                        data={
                            testResultDetails || []
                        }
                        selection={true}
                        sortBy={criteria.sort}
                        selectionChanged={selectionChanged}
                        formatDate={formatDate}
                        onFilterChanged={onFilterChanged}
                        criteria={criteria}
                        testResultFullAudio={testResultFullAudio}
                    />

                )}



                <Modal
                    isOpen={isOpen}
                    title={t("Delete Items")}
                    small={true}
                    deleteConfirmation={true}
                    ButtonDelete={deleteTestResult}
                />

                <Modal
                    isOpen={openJiraModal}
                    className={'full-width'}
                    title={testResultDetails?.testResult?.jiraTicket ? t("Modify Jira Ticket"):t("Create a Jira Ticket")}
                    body={<JiraTicket testResultDetails={testResultDetails} project={project}  cancel={closeJiraModal} channel={project?.data?.channelType}/>}
                />
            </Grid>
        </DndProvider>

    );
};
